function getVariantAvailabilityState(variant) {
  if (!variant) return null;

  const dispatchDate = window.variantMetafields?.[variant.id]?.estimated_dispatch;

  const inStock = variant.inventory_quantity > 0;
  const continueSelling = variant.inventory_policy === "continue";

  if (inStock) return 1;
  if (!continueSelling) return 2;
  if (dispatchDate) return 3;
  return 4;
}


function updateATCButton(variant) {
  const btn = document.querySelector("#main-atc-button");
  if (!btn) return;

  const span = btn.querySelector("span");
  const state = getVariantAvailabilityState(variant);

  switch(state) {
    case 1: // In-stock
      btn.disabled = false;
      btn.classList.remove("disabled", "preorder");
      span.textContent = "Add to Cart";
      break;

    case 2: // Sold-out
      btn.disabled = true;
      btn.classList.add("disabled");
      btn.classList.remove("preorder");
      span.textContent = "Sold Out";
      break;

    case 3: // Preorder
      btn.disabled = false;
      btn.classList.add("preorder");
      btn.classList.remove("disabled");
      span.textContent = "Pre Order";
      break;

    case 4: // Backorder
      btn.disabled = false;
      btn.classList.remove("disabled", "preorder");
      span.textContent = "Add to Cart";
      break;
  }
}


function updateLeaveWarehouseBlock(variant, product) {
  const block = document.querySelector("#leave-warehouse-block");
  const christmasBlock = document.querySelector("#christmasDeliveryMesg"); // <--- NEW SELECTION

  if (!block) return;

  const prefix = block.querySelector(".prefix");
  const msg = block.querySelector(".dispatchmessage");

  const beQuick = block.querySelector(".bequick-msg");
  const beQuickInline = block.querySelector(".bequick-inline-msg");

  const dispatch = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const state = getVariantAvailabilityState(variant);

  // Hide entire block if out of stock and cannot sell
  if (state === 2) {
    block.style.display = "none";
    if (christmasBlock) christmasBlock.style.display = "none"; // Hide Christmas msg if sold out
    return;
  }

  block.style.display = "flex";

  // BE QUICK logic (product-level tag check)
  const hasBeQuick = product?.tags?.includes("change-dispatch-quick");
  beQuick.style.display = hasBeQuick ? "inline" : "none";
  beQuickInline.style.display = hasBeQuick ? "inline" : "none";

  if (hasBeQuick) {
    prefix.textContent = "";
    msg.textContent = "";
    if (christmasBlock) christmasBlock.style.display = "none"; // Hide Christmas msg if 'Be Quick' is active
    return;
  }

  // Dispatch/delivery logic matching your 4-state function
  if (state === 3) {
    prefix.textContent = "Estimated dispatch:";
    msg.textContent = dispatch;
  } else if (state === 1) {
    prefix.textContent = "Estimated delivery:";
    msg.textContent = "with you in 48 hours";
  } else if (state === 4) {
    prefix.textContent = "Estimated dispatch:";
    msg.textContent = dispatch || "with you in 48 hours";
  }

  // --- NEW CHRISTMAS LOGIC SECTION ---
  if (christmasBlock) {
    // We check for State 1 (In Stock) OR State 4 (Backorder) where there is NO dispatch date.
    // These are the two scenarios where your code outputs "with you in 48 hours".
    const is48HourMsg = (state === 1) || (state === 4 && !dispatch);

    if (is48HourMsg) {
      christmasBlock.innerHTML = "🎄 Arrives before <strong>Christmas</strong>";
      christmasBlock.style.display = "block";
    } else {
      christmasBlock.style.display = "none";
    }
  }
  // ------------------------------------
}



function updateProductUI(selectedVariant) {
  const product = window.productData || window.meta?.product;
  updateATCButton(selectedVariant);
  updateLeaveWarehouseBlock(selectedVariant, product);
}



// Hook into variant selection
document.addEventListener("variant:changed", (event) => {
  const variant = event.detail.variant;
  if (variant) updateProductUI(variant);
});

// Initial load
document.addEventListener("DOMContentLoaded", () => {
  const variantIdInput = document.querySelector('input[name="id"].product-variant-id');
  const variantId = variantIdInput ? variantIdInput.value : null;

  if (!variantId) {
    console.warn("No initial variant ID found.");
    return;
  }

  // Find matching variant from the product JSON in the page
  const productData = window.productData || window.meta?.product;
  if (!productData) {
    console.warn("No product JSON found in window.");
    return;
  }

  const initialVariant = productData.variants.find(v => String(v.id) === String(variantId));

  if (!initialVariant) {
    console.warn("Initial variant could not be matched.");
    return;
  }

  updateProductUI(initialVariant);
});
